define('HomeFeaturedProducts.Home.View', [
    'Home.View',
    'underscore'
], function HomeFeaturedProductsHomeView(
    HomeView,
    _
) {
    'use strict';

    _.extend(HomeView.prototype, {
        showError: function showError() {
            return null;
        }
    });
});
